/* eslint-disable react-hooks/exhaustive-deps */
import { useLiveQuery } from "dexie-react-hooks";
import { useEffect, useMemo, useState } from "react";
import { db } from "~/db/db";
import useSelect from "~components/Form/hooks/useSelect";
import prepareForOptions from "~services/utils/prepareForOptions";

const useFunilObraMotivoPerda = ({ formikRef, name = "funilObraMotivoPerdaId" }) => {
  const funilObraMotivoPerdaSelect = useSelect(name);
  const [funilObraMotivoPerda, setFunilObraMotivoPerda] = useState(0);

  const [funilObraMotivosPerda, setFunilObraMotivosPerda] = useState([]);

  useEffect(() => {
    const fetchMotivosPerda = async () => {
      const result = [];
      await db.funilObraMotivoPerda.each((item) => result.push(item));
      setFunilObraMotivosPerda(result);
    };

    fetchMotivosPerda();
  }, []);

  const optionFunilObraMotivosPerda = useMemo(() => prepareForOptions(funilObraMotivosPerda.filter(c => c.ativo), ['nome'], 'id'), [funilObraMotivosPerda]);

  function onChangeFunilObraMotivosPerda(e) {
    funilObraMotivoPerdaSelect.upDateValue(e.value);
    funilObraMotivoPerdaSelect.upDateDefaultValue(e || "");
    formikRef.current.setFieldValue(name, e.value);
    setTimeout(() => formikRef.current.setFieldTouched(name, true));
    setFunilObraMotivoPerda(e.value);
  }

  function setSelectConcorrente(id) {
    const funilObraMotivoPerda = optionFunilObraMotivosPerda.find((o) => o.value === id);
    if (funilObraMotivoPerda)
      onChangeFunilObraMotivosPerda(funilObraMotivoPerda);
  }

  const concorrenteSelecionado = useMemo(() => {
    if(funilObraMotivoPerda && funilObraMotivoPerda != 0)
      return funilObraMotivosPerda?.find(e => e.id == funilObraMotivoPerda);
    return null;
  }, [funilObraMotivoPerda])

  return {
    concorrenteSelecionado,
    funilObraMotivosPerda,
    optionFunilObraMotivosPerda,
    onChangeFunilObraMotivosPerda,
    setSelectConcorrente,
    funilObraMotivoPerda,
    funilObraMotivoPerdaSelect,
    setFunilObraMotivoPerda
  };
}

export default useFunilObraMotivoPerda;